<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Kawalan Kualiti Semen Beku" >
      <w-card bg-color="" class="">
        <w-flex justify-center align-center v-if="id == 0">
              <div class="xs4">
                  <!-- <w-input label="No Batch" v-model="cari" /> -->
                  <z-select class="mt4" :items="batch" label="No Batch "  v-model="cari" @input="getCari()" />
              </div>
              <div class="xs8">
                  <!-- <w-button class="ml1" @click="getCari">Cari</w-button> -->
              </div>
          </w-flex>
        <div class="w-flex wrap smd-column"  v-if="data.id > 0">
          
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody>
                  <tr class="row_data">
                     <td><b> Nombor Batch </b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_batch}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID Ternakan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Masa Pungutan </b></td>
                     <td><b>:</b></td>
                     <td>{{data.tarikh}} {{data.masa}}</td>
                  </tr>
                  <!-- <tr class="row_data">
                     <td><b>Jumlah Panjatan Palsu </b></td>
                     <td><b>:</b></td>
                     <td>{{data.jumlah_penjatan_palsu}}</td>
                  </tr> -->
                  <tr class="row_data">
                     <td><b>Tujahan (1-5) </b></td>
                     <td><b>:</b></td>
                     <td>{{data.tujahan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Kepekatan sperma /ml</b></td>
                     <td><b>:</b></td>
                     <td>{{data.kepekatan_sperma}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Status Kawalan Kualiti </b></td>
                     <td><b>:</b></td>
                     <td>{{data.status}}</td>
                  </tr>
                 </tbody>
               </table>
               
              </div>
              <div class="mx2"></div>
              <div class="grow ">

                <table >
                  <tbody>
                  <tr class="row_data">
                     <td><b>Libido (0-10) </b></td>
                     <td><b>:</b></td>
                     <td>{{data.libido}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Warna </b></td>
                     <td><b>:</b></td>
                     <td>{{data.warna}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Ketumpatan Semen (0-5)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.skor_ketumpatan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Isipadu Semen (ml) </b></td>
                     <td><b>:</b></td>
                     <td>{{data.isipadu}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Keaktifan sperma (Aktiviti Massa/skor 0-5) </b></td>
                     <td><b>:</b></td>
                     <td>{{data.stor_keaktifan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>% Motiliti Progresif (beku)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.motiliti_beku}}</td>
                  </tr>
                  </tbody>
                </table>
                
              </div>
            </div>
            
          </div>
        </div>
       <br><br>
        <w-tabs :items="tabs" :no-slider="false" active-class="primary" class="tabs2" v-model="activeTab" v-if="data.id > 0" card >
          <template #item-title.1="{ item }" >
            
            <template v-if="data.pemeriksaan_hantar == 1">
              <div  class="green_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="success" ><samp class="success">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
            <template v-else-if="data.pemeriksaan_hantar == 2">
              <div  class="yellow_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="warning" ><samp class="warning">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
             <template v-else>
              <div  class="red_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="error" ><samp class="error">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
          
          </template>
          <template #item-title.2="{ item }">
            <template v-if="data.kemandirian_hantar == 1">
              <div  class="green_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="success" ><samp class="success">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
            <template v-else-if="data.kemandirian_hantar == 2">
              <div  class="yellow_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="warning" ><samp class="warning">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
             <template v-else>
              <div  class="red_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="error" ><samp class="error">{{ item.title }}</samp> </w-badge>&nbsp;&nbsp; -->
            </template>
          </template>
          <template #item-title.3="{ item }">
            <template v-if="data.saringan_hantar == 1">
              <div  class="green_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="success" ><samp class="success">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
            <template v-else-if="data.saringan_hantar == 2">
              <div  class="yellow_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="warning" ><samp class="warning">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
             <template v-else>
              <div  class="red_tab"> {{ item.title }}</div>
              <!-- <w-badge  bg-color="error" ><samp class="error">{{ item.title }} </samp></w-badge>&nbsp;&nbsp; -->
            </template>
          </template>
          <template #item-content.1>
            
            <Pemeriksaan :d_data="data" v-if="data.id > 0 && load == 1"/>
          </template>
           <template #item-content.2>
             <Kemandirian :d_data="data" v-if="data.id > 0 && load == 1"/>
          </template>
          <template #item-content.3>
             <SariangPenyakit :d_data="data" v-if="data.id > 0 && load == 1"/>
          </template>
        </w-tabs>

        &nbsp;&nbsp;&nbsp;&nbsp;<w-badge  bg-color="error" left >:  Belum diisi</w-badge> <br>
        &nbsp;&nbsp;&nbsp;&nbsp;<w-badge  bg-color="yellow" left >:  Data disimpan </w-badge> <br>
        &nbsp;&nbsp;&nbsp;&nbsp;<w-badge  bg-color="success" left >:  Dihantar </w-badge> <br>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-card>
      
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

import Pemeriksaan from "./Sub/Pemeriksaan.vue";
import SariangPenyakit from "./Sub/SariangPenyakit.vue";
import Kemandirian from "./Sub/Kemandirian.vue";


export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide,Pemeriksaan,SariangPenyakit,Kemandirian
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'se.katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Kawalan Kualiti Semen Beku', route: '/se/kawalan' },
        { label: 'Papar', route: '/se/kawalan/'+this.id },
      ],
      data : {id : this.id},
      cari : '',
      batch : [],
      activeTab : 0,
      laod : 0,
      tabs: [
      		  { title: 'Penilaian Kualiti', content: '' },
              { title: 'Ujian Kemandirian ', content: '' },
              { title: 'Ujian Saringan Penyakit', content: '' },
            
          ]
    }
  },
  methods: {
     tutup(){
      this.$inertia.visit(window.route('se.kawalan.index'));
    },
    getData()
    {
      if(this.data.id > 0){
        this.$zcomm.get(this.api_service + 'se_pemungutan/show/'+this.data.id, {}).then(res => {
          this.data = res
          this.load = 1
        })
      }

    },

    getCari()
    {
     
        // this.$zcomm.get(this.api_service + 'se_pemungutan/cari?no_batch='+this.cari, {}).then(res => {
        //   this.data = res
          
        // })

        this.data.id = this.cari
        this.getData()
      

    },

    getBatch()
    {
     
        this.$zcomm.get(this.api_service + 'lookup/no_batch_kawalan', {}).then(res => {
          this.batch = res
          
        })
      

    },
   

  },
  watch: {

  },
  mounted() {
    this.getData();
    this.getBatch();
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.t ){
      this.activeTab = this.params.t
    }
  },
}
</script>
<style type="text/css">
  .tabs2 .w-tabs__bar .w-tabs__bar-item{
          padding : 1px 1px !important;
  }
  .red_tab{
    /*background-image: radial-gradient( circle 817.6px at 10% 20%,  rgba(178,34,34,1) 0%, rgba(255,87,51,1) 41.9%, rgba(255,165,0,1) 100.2% );*/
    background-color: #F45156;
    padding: 12px 8px;
  }
  .yellow_tab{
    background-image: radial-gradient( circle 331px at 1.4% 52.9%,  rgba(255,236,2,1) 0%, rgba(255,223,2,1) 33.6%, rgba(255,187,29,1) 61%, rgba(255,175,7,1) 100.7% );
    padding: 12px 8px;
  }
  .green_tab{
    background-image: radial-gradient( circle 963px at 1.9% 5%,  rgba(0,193,80,1) 0%, rgba(0,112,198,1) 100.2% );
    padding: 12px 8px;
  }



   table {
     width: 100%;
     border-collapse: collapse;
   }

   .row_data td {
     padding: 6px 4px;   
     font-size: 14px;
     color: #333;
   }


   .row_data td:first-child {
     width: 220px;         
     padding-right: 10px;
     font-weight: 600;
   }


   .row_data td:nth-child(2) {
     width: 15px;
     text-align: center;
     font-weight: bold;
   }


   .row_data td:last-child {
     font-weight: 500;
   }


   .w-flex table {
     margin-bottom: 12px;
   }

   
   .table-status td:first-child {
     width: 120px !important;     /* sebelum 190px → jadi 120px */
     padding-right: 8px;
     font-weight: 600;
   }

   .table-status td:nth-child(2) {
     width: 12px !important;
     text-align: center;
   }


</style>
